import { farms_backend } from "../config/api.config";

export default function HeaderFarms(token_365) {
  const apiKey = farms_backend.api_key;

  return { "x-api-key": apiKey, "x-access-token": token_365 };
}
